import { Link } from 'react-router-dom';

const Header = ({ showBack = false, backTo = '/' }) => {
  return (
    <header className="header">
      <div className="max-w-5xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img 
            src="https://customer-assets.emergentagent.com/job_64dc7c1a-b9b7-4a71-8abb-3e97b4d0b668/artifacts/cgp14kve_DEAFEA-Logo-exp.png" 
            alt="Dea Fea" 
            className="h-8 w-auto"
          />
        </Link>
        
        <div className="flex items-center gap-6">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-muted-foreground">
            Resi & Cambi
          </span>
          
          {showBack && (
            <Link 
              to={backTo}
              className="text-xs font-bold tracking-[0.15em] uppercase text-primary hover:underline underline-offset-4"
            >
              Indietro
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
